import React from 'react';
import { Button as ButtonComponent } from 'payu-ui-v2';

export const Button = ({
  className,
  children,
  variant,
  onClick,
  loading,
  disabled,
  type,
  startIcon,
  size,
}) => {
  return (
    <ButtonComponent
      className={className}
      variant={variant}
      onClick={onClick}
      type={type}
      loading={loading}
      disabled={disabled}
      startIcon={startIcon}
      size={size}
    >
      {children}
    </ButtonComponent>
  )
}